import { motion } from "framer-motion";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger
} from "@/components/ui/accordion";
import { revealUp, fadeRight } from "./animation-variants";

const faqs = [
  { q: "Hur fungerar AI-genereringen?", a: "Vår AI analyserar din bransch, tonalitet och målgrupp för att skapa skräddarsydda inlägg. Du anger din brand voice och bransch vid onboarding – sedan genererar AI:n anpassat innehåll som du enkelt kan redigera och publicera." },
  { q: "Vilka sociala plattformar stöds?", a: "Zensio stöder Facebook, Instagram, LinkedIn, Twitter/X och TikTok. Varje inlägg optimeras automatiskt för respektive plattforms format, längd och hashtag-strategier." },
  { q: "Kan jag prova gratis?", a: "Ja. Du får 14 dagars gratis demo utan att ange betaluppgifter, med full åtkomst till Starter-planen (30 AI-inlägg/mån, 2 kanaler). Efter demoperioden väljer du plan eller pausar kontot." },
  { q: "Vad är skillnaden mellan Starter, Pro och Byrå?", a: "Starter (499 kr/mån) är för dig som bara vill komma igång med sociala medier. Pro (1 299 kr/mån) låser upp hela plattformen: CRM, offerter, kampanjer, nyhetsbrev, AI-inbox, Företagets minne, Fortnox-integration och den autonoma AI-agenten. Byrå (2 499 kr/mån) lägger till stöd för upp till 10 kunder, team-roller och white-label. Alla priser exkl. moms." },
  { q: "Vad är den autonoma AI-agenten?", a: "En agent som varje morgon läser din verksamhet, publicerar godkända utkast, svarar på supportärenden inom din tröskel, kvalificerar leads och skickar en morgonbrief. Du bestämmer själv vilka moduler den ska agera på och vilka som bara ska föreslå. Ingår i Pro och Byrå." },
  { q: "Är mitt innehåll GDPR-kompatibelt?", a: "Ja. All data lagras inom EU och vi följer GDPR fullt ut. Vi delar aldrig ditt innehåll eller din data med tredje part utan ditt samtycke." },
  { q: "Kan jag använda Zensio i ett team?", a: "Ja. På Byrå-planen kan du bjuda in kollegor, tilldela roller (admin, redigerare, läsare), lägga upp godkännandeflöden och samarbeta kring innehåll i realtid." },
  { q: "Hur fungerar blogg-till-social-funktionen?", a: "Klistra in en bloggtext eller RSS-länk, så genererar AI:n anpassade poster för varje plattform – med rätt längd, hashtags och call-to-action." },
  { q: "Kan jag byta plan senare?", a: "Ja, när som helst från /prenumeration. Uppgraderar du direkt slås nya funktioner på; nedgraderar du gäller den nya planen från nästa fakturaperiod. Fakturering sker via Stripe (kort, Klarna) eller manuell faktura." },
];

export { faqs };

export default function FaqSection() {
  return (
    <section id="faq" className="relative border-t border-foreground/10 py-20 md:py-28">
      <div className="container">
        <div className="grid gap-10 md:grid-cols-12">
          <motion.div
            variants={revealUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0}
            className="md:col-span-4"
          >
            <span className="font-mono text-xs text-secondary tracking-widest">— 04</span>
            <p className="mt-2 text-xs uppercase tracking-[0.2em] text-muted-foreground">FAQ</p>
            <h2 className="mt-6 font-display font-light text-3xl md:text-5xl text-foreground tracking-[-0.02em] leading-[1.05]">
              Vanliga{" "}
              <span className="italic text-secondary">frågor.</span>
            </h2>
            <p className="mt-6 text-sm text-foreground/65 max-w-xs">
              Hittar du inte svaret?{" "}
              <a href="mailto:info@zensio.se" className="text-secondary underline underline-offset-4 hover:text-secondary/70">
                info@zensio.se
              </a>
            </p>
          </motion.div>

          <motion.div
            variants={fadeRight}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0.08}
            className="md:col-span-8 border-t border-foreground/10"
          >
            <Accordion type="single" collapsible>
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="border-b border-foreground/10 px-0"
                >
                  <AccordionTrigger className="py-6 text-left font-display font-normal text-lg md:text-xl tracking-[-0.01em] text-foreground hover:text-secondary hover:no-underline transition-colors">
                    <span className="flex items-baseline gap-4 md:gap-6">
                      <span className="font-mono text-xs text-secondary shrink-0 pt-1">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span>{faq.q}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-12 md:pl-14 text-base leading-relaxed text-foreground/65">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
